export default __webpack_public_path__ + "static/media/modal_bg.b0241e7c.jpg";